import { cx } from '@emotion/css';
import { useFormContext } from 'react-hook-form';
import { PropsWithChildren } from 'react';
import { Hint } from '@phoenix/design-system/frontend/ui/form/hint/hint';
import { HookFormCheckboxProps } from './hook-form-checkbox.types';
import { Checkbox } from '@phoenix/design-system/frontend/ui/form/checkbox/checkbox';
import { HintType } from '@phoenix/design-system/frontend/ui/form';

export const HookFormCheckbox = ({
  name,
  className,
  description,
  disabled,
  required = false,
  label,
  id,
  value,
  hasError,
  children,
  ...restProps
}: PropsWithChildren<HookFormCheckboxProps>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const hint = errors[name]?.message && {
    message: errors[name]?.message,
    type: 'error' as HintType,
    dataTestId: `${name}ValidationErrorMessage`,
  };

  return (
    <div className={cx('mb-4 lg:mb-m', className)} {...restProps}>
      <Checkbox
        className={cx(errors[name] && 'is-invalid')}
        {...register(name)}
        value={value}
        disabled={disabled}
        htmlFor={id || name}
        required={required}
      >
        {children}
      </Checkbox>
      {description && <div className="mt-1 stihl-text-body-xs-reg">{description}</div>}
      {hint && <Hint {...hint} />}
    </div>
  );
};
